/**
 * Formatta il codice di repertorio completo
 * @method calcNumeroRepertorioCompleto
 * @param numeroRepertorio
 * @param suffissoRepertorio
 * @returns {string|*}
 */
function calcNumeroRepertorioCompleto(numeroRepertorio, suffissoRepertorio) {
  if (!numeroRepertorio && !suffissoRepertorio) {
    return '-'
  }
  return (numeroRepertorio ? numeroRepertorio : '-') + (suffissoRepertorio ? '/' + suffissoRepertorio : '');
}

/**
 * Formatta il codice di raccolta completo
 * @method calcNumeroRaccoltaCompleto
 * @param numeroRaccolta
 * @param suffissoRaccolta
 * @returns {string|*}
 */
function calcNumeroRaccoltaCompleto(numeroRaccolta, suffissoRaccolta) {
  if (!numeroRaccolta && !suffissoRaccolta) {
    return '-'
  }
  return (numeroRaccolta ? numeroRaccolta : '-') + (suffissoRaccolta ? '/' + suffissoRaccolta : '');
}

export {calcNumeroRepertorioCompleto, calcNumeroRaccoltaCompleto}